var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeOff = function SvgVolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 5 5 9H1v6h4l5 4V5Z",
    stroke: "#F6650A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22 9-6 6M16 9l6 6",
    stroke: "#F6650A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgVolumeOff as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 5L5 9H1V15H5L10 19V5Z' stroke='%23F6650A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M22 9L16 15' stroke='%23F6650A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M16 9L22 15' stroke='%23F6650A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";